import { styled } from '@mui/material';

export const PageW = styled('div')`
  display: flex;
  flex-direction: column;
  padding-left: 38px;
  padding-top: 64px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 80px 16px;
  }

  @media (min-width: 1920px) {
    align-items: center;
  }
`;

export const ContentW = styled('div')`
  width: 100%;
`;

export const HeaderActionsW = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PageTitle = styled('div')`
  margin: 0;
  white-space: nowrap;
  font-size: 24px;
  font-weight: 700;
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
